import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { ArcadeGameDetailsScreen } from '@/feature/game-details-arcade/screens/ArcadeGameDetailsScreen';
import { ArcadeLobbyScreen } from '@/feature/lobby-arcade/screens/ArcadeLobby';
import { PromoHubStack } from '@/feature/promohub/PromohubStack';

import { ArcadeLobbyStackParamList } from './types';

const Stack = createNativeStackNavigator<ArcadeLobbyStackParamList>();

export const LobbyStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="ArcadeLobbyScreen" component={ArcadeLobbyScreen} />
            <Stack.Screen name="ArcadeGameDetailsScreen" component={ArcadeGameDetailsScreen} />
            <Stack.Screen name="LobbyPromohub" component={PromoHubStack} />
        </Stack.Navigator>
    );
};
